import DeleteCostModal from './DeleteCostModal.vue';

export default DeleteCostModal;
